import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=087c9646&scoped=true"
import script from "./ProductCard.vue?vue&type=script&lang=ts"
export * from "./ProductCard.vue?vue&type=script&lang=ts"
import style0 from "./ProductCard.vue?vue&type=style&index=0&id=087c9646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087c9646",
  null
  
)

export default component.exports